import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { Alert, Button, Container, Image, Text, Title } from "@mantine/core";

import { useOpenPersonalLink } from "../api/user";
import Logo from "../assets/logo-02.svg";
import LoadingPage from "../components/common/LoadingPage";

function ExpiredLink({ contactEmail }) {
  return (
    <>
      <Title order={3} mb="xs">
        Link expired
      </Title>
      <Text mb="md">
        This link has expired. Contact the organizer to get a new one.
      </Text>
      {contactEmail && (
        <Button
          component="a"
          href={`mailto:${contactEmail}`}
          fullWidth
          size="md"
        >
          Contact organizer
        </Button>
      )}
    </>
  );
}

export default function OpenDocument() {
  const { token } = useParams();
  const { data, isLoading, isError } = useOpenPersonalLink(token);

  useEffect(() => {
    if (data?.status === "valid") window.location.replace(data.url);
  }, [data]);

  if (isLoading || data?.status === "valid") {
    return <LoadingPage />;
  }

  return (
    <Container size={420}>
      <Image src={Logo} alt="congrs logo" />
      {isError || !data ? (
        <Alert color="red">This document is no longer available.</Alert>
      ) : (
        <ExpiredLink contactEmail={data.contactEmail} />
      )}
    </Container>
  );
}
